import { render, staticRenderFns } from "./create.vue?vue&type=template&id=20fdb473&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fdb473",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fdb473')) {
      api.createRecord('20fdb473', component.options)
    } else {
      api.reload('20fdb473', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=20fdb473&scoped=true", function () {
      api.rerender('20fdb473', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qrcode/create.vue"
export default component.exports